var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgRedNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E55C42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0444 2.85718C9.24964 2.85718 8.62939 3.28363 8.62939 4.03963C8.62939 6.34624 8.90072 9.66081 8.90072 11.9675C8.90078 12.5684 9.42419 12.8203 10.0444 12.8203C10.5096 12.8203 11.1687 12.5684 11.1687 11.9675C11.1687 9.66088 11.44 6.3463 11.44 4.03963C11.44 3.28369 10.8004 2.85718 10.0444 2.85718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0639 14.1577C9.21103 14.1577 8.57129 14.8361 8.57129 15.6503C8.57129 16.445 9.21096 17.1429 10.0639 17.1429C10.8586 17.1429 11.5371 16.445 11.5371 15.6503C11.5371 14.8361 10.8585 14.1577 10.0639 14.1577Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedNotification);
export default __webpack_public_path__ + "static/media/RedNotification.e366af47ce1d60722ad7b421d7f1f508.svg";
export { ForwardRef as ReactComponent };